<template>
    <AuthLayout>
        <div
            class="mt-8 flex w-full flex-col items-center overflow-hidden bg-white p-6 shadow-xl sm:mt-14 sm:max-w-md sm:rounded-lg"
        >
            <div class="-mt-1 h-[240px] w-[240px]">
                <img
                    src="https://d5aoblv5p04cg.cloudfront.net/application/images/auth/forgotten-email@2x.png"
                    class="ml-[10px] mt-[10px] h-full w-full"
                    alt="Rhizom Illustration"
                />
            </div>

            <div class="mt-[14px] text-xl font-bold text-gray-800">
                {{ $t("vue.check_your_inbox") }}
            </div>

            <div
                class="mb-[31px] mt-3 max-w-sm text-center text-sm text-gray-500"
            >
                {{ $t("vue.sent_password_reset_instructions") }}
            </div>
        </div>
    </AuthLayout>
</template>

<script lang="ts" setup></script>
